import Card from "../../util/card/Card.jsx";
import InternalLink from "../../util/navigation/InternalLink.jsx";
import {APP_ROUTES} from "../../../App.jsx";
import {DECIMAL_FORMAT, numberFormat} from "../../../util/numbers.js";
import {useSelector} from "react-redux";
import {getAssetRate} from "../../../ducks/assets-duck.js";
import './ConnectedTransaction.scss'
import ValueChange from "../../util/ValueChange.jsx";
import LinkVariantIcon from "mdi-react/LinkVariantIcon.js";

export default ({
                    id,
                    cost,
                    asset_name,
                    asset_code,
                    fund_id,
                    amount,
                }) => {
    const currentRate = useSelector(state => getAssetRate(state, fund_id))
    const currentValue = Math.abs(amount * currentRate)
    return (
        <Card className='connected-transaction'>
            <LinkVariantIcon className='link-icon'/>
            <h4>
                Connection
            </h4>
            <div className='flex-vertical-center'>
                <div className='asset-name'>
                    {asset_name}
                </div>
                <span className='quantity hide-portrait'>
                    <span
                        className='code'>{amount < 0 ? 'sell' : 'buy'}</span> {numberFormat(Math.abs(amount), DECIMAL_FORMAT.FLEX_DEC)}
                    <span className='code'>{asset_code}</span>
                </span>
                <ValueChange
                    valueFrom={cost}
                    valueTo={currentValue}
                    isReductionPositive={cost < 0}
                />
            </div>
            <InternalLink to={APP_ROUTES.transactionsPage.replace(`:transactionId`, id)}>
                Go to linked transaction
            </InternalLink>
        </Card>
    )
}